function createProductObjectsAndFindPromos() {
    const productVariants = document.querySelectorAll('.product-form .paperback-conditions-container input, .product-form .hardback-conditions-container input, .product-form .condition-selector-container input');

    productVariants.forEach(variant => {
        const product = {
            condition: variant.getAttribute('data-condition'),
            fromPrice: variant.getAttribute('data-price') / 100, // Convert pence to pounds
            collection_ids: variant.getAttribute('data-collection')
                .split(',')
                .map(id => id.trim())
                .filter(id => id && id !== "' '" && id !== '" "'),
            sku: variant.getAttribute('data-sku'),
        };
        
        const matchingPromos = findQualifyingPromotions(product);
        // If there are matching promos, add details to the element
        if (matchingPromos.length > 0) {
            const promoDetails = matchingPromos.map(promo => ({
                title: promo.title,
                message: promo.message,
                shortMessage: promo.shortMessage,
                color: promo.color,
                fontColor: promo.fontColor,
                promoUrl: promo.promoUrl // Added promotionUrl to the promo details
            }));

            // Insert HTML element at the end of the div
            const promoElement = document.createElement('span');
            promoElement.setAttribute("class","deal-banner");
            promoElement.innerHTML = `Deal!`;
            variant.closest('.radio_button_container').appendChild(promoElement);
            // Add data-promos attribute with JSON object of promo details
            variant.setAttribute('data-promos', JSON.stringify(promoDetails));
            document.dispatchEvent(new CustomEvent("sticky-condition-deal", {
                detail: {
                    variant: variant
                }
            }));
        }
        // Adding event listener to each radio button for the click event
        variant.addEventListener('click', function () {
            displayPromosForVariant(this);
        });
    });
}

function displayPromosForVariant(variant) {
    const promosData = variant.getAttribute('data-promos');
    const promos = JSON.parse(promosData); // Parse the JSON string to an object
    const variantPromosDiv = document.getElementById('promotions-container');
    const pdpMediaBadgeDiv = document.getElementById('badge-container');

    // Clear previous promos
    variantPromosDiv.innerHTML = '';
    if (pdpMediaBadgeDiv !== null) {
        pdpMediaBadgeDiv.innerHTML = '';
    }
    // Check if there are promos to display
    if (promos && promos.length > 0) {
        promos.forEach(promo => {
            // ${promo.title} 
            // Create HTML elements for each promo and append to variantPromosDiv
            //console.log(promo,"promo")
            const promoSpan = document.createElement('span');
            promoSpan.setAttribute("class","promo");
            promoSpan.style.color = `#${promo.fontColor}`;
            promoSpan.style.backgroundColor = `#${promo.color}`;
            promoSpan.innerHTML = `<h6 class='promo-title'>Special Offer</h6>${promo.message}`;
            variantPromosDiv.appendChild(promoSpan);

            if (promo.promoUrl) {
                const promoLink = document.createElement('a');
                promoLink.href = promo.promoUrl;
                promoLink.appendChild(promoSpan);
                variantPromosDiv.appendChild(promoLink);
            } else {
                variantPromosDiv.appendChild(promoSpan);
            }

            if(pdpMediaBadgeDiv !== null) {
                // Create badge on PDP overlay media
                const promobadge = document.createElement('div');
                const promobadgeSpan = document.createElement('span');
                promobadge.appendChild(promobadgeSpan);
                promobadgeSpan.style.color = `#${promo.fontColor}`;
                promobadgeSpan.style.backgroundColor = `#${promo.color}`;
                promobadgeSpan.textContent = `${promo.shortMessage}`;
                pdpMediaBadgeDiv.appendChild(promobadge);
            }
        });
    }
}

document.addEventListener('DOMContentLoaded', () => {
    createProductObjectsAndFindPromos();
});